import { Injectable } from '@angular/core';

export class EnvironmentInfo {
  logoutUrl = '';
  loginUrl = '';
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  csrUrl = '';
  loginUrl = '';
  logoutUrl = '';
  profileUrl = '';
  portalUrl = '';

  constructor() {
    const name = this.getName();
    this.csrUrl = `https://assessorsso${name}.assessor.lacounty.gov/csr`;
    this.loginUrl = `https://assessorsso${name}.assessor.lacounty.gov/csr?backUrl=https%3A%2F%2Fassessor${name}.lacounty.gov%2Flogin`;
    this.logoutUrl = `https://assessorsso${name}.assessor.lacounty.gov/oamsso/logout.html?end_url=${window.location.origin}`;
    this.profileUrl = `https://assessorsso${name}.assessor.lacounty.gov/identity/faces/home?tf=my_information`;
    this.portalUrl = `https://assessorportal${name}.assessor.lacounty.gov/webcenter/AssessorPortal.html`;
  }

  isQA(): boolean {
    return this.getName() === 'stg';
  }

  isLocalHost(): boolean {
    return window.location.host === 'localhost:4200';
  }

  getName(): string {
    switch (window.location.host) {
      case 'assessor.lacounty.gov':
      case 'localhost:5001':
      case 'localhost:4200':
        return '';
      case 'assessorqa.lacounty.gov':
        return 'stg';
      case 'assessorpstst.lacounty.gov':
        return 'pstst';
      case 'assessorate2.lacounty.gov':
        return 'ate1';
      case 'assessorate3.lacounty.gov':
        return 'ate1';
      default:
        return 'NOT_SET';
    }
  }

  getRootTabName(): string {
    const prefix = 'Assessor';
    switch (window.location.host) {
      case 'assessor.lacounty.gov':
        return prefix;
      case 'localhost:5001':
      case 'localhost:4200':
        return prefix + ' LH';
      case 'assessorqa.lacounty.gov':
        return prefix + ' QA';
      case 'assessorpstst.lacounty.gov':
        return prefix + ' PSTST';
      case 'assessorate2.lacounty.gov':
        return prefix + ' ATE2';
      case 'assessorate3.lacounty.gov':
        return prefix + ' ATE3';
      default:
        return 'NOT_SET';
    }
  }

}
